import React, { useMemo } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { INLINES, BLOCKS } from "@contentful/rich-text-types";
import PropTypes from "prop-types";
import SocialComponent from "@/components/SocialComponent";

export const RichText = ({
  text,
  urlTarget = "New Tab",
  paragraphCustomClasses,
  showPrinShare = false,
}) => {
  const target = urlTarget === "New Tab" ? "_blank" : "";
  const options = useMemo(
    () => ({
      renderNode: {
        [INLINES.HYPERLINK]: (node, children) => {
          return (
            <a
              target={target}
              rel="noopener noreferrer"
              className="text-[#337ab7]"
              style={{fontFamily: "HelveticaRoman, Helvetica, sans-serif" }}
              href={node.data.uri}
            >
              {children}
            </a>
          );
        },
        [BLOCKS.PARAGRAPH]: (node, children) => (
          <p className="text-[14px]" style={{ whiteSpace: "pre-line",fontFamily: "HelveticaRoman, Helvetica, sans-serif" }}>
            {children}
          </p>
        ),

        [BLOCKS.UL_LIST]: (node, children) => (
          <ul className="list-disc ml-5 pl-10 ">{children}</ul>
        ),

        [BLOCKS.LIST_ITEM]: (node, children) => <li>{children}</li>,
      },
      renderText: text => {
        return text.split("\n").reduce((children, textSegment, index) => {
          return [...children, index > 0 && <br key={index} />, textSegment];
        }, []);
      },
    }),
    [paragraphCustomClasses, target]
  );
  const renderedText = documentToReactComponents(text, options);

  return (
    <div className="rich-text">
      {renderedText}
      <div>{showPrinShare && <SocialComponent />}</div>
    </div>
  );
};

RichText.propTypes = {
  text: PropTypes.object,
  urlTarget: PropTypes.oneOf(["New Tab", ""]),
  paragraphCustomClasses: PropTypes.string,
  showPrinShare: PropTypes.bool,
};
